// var url='https://aip.baidubce.com/oauth/2.0/token?grant_type=client_credentials&client_id=3Q0dARwnDHr3PlsgBie7oIaY&client_secret=4p5UrwCncRlsDED6B9QK0iZN4tN7AxET&';
import axios from 'axios';
import VueAxios from 'vue-axios';
import global from '../components/global'
import router from "../router";
// export const BASE_URL ='/csbdc/newtfw' ;
// import {LOG_OUT} from '../constants/index.js'
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

/**
 * 请求之前可以做什么
 */
//设置请求头
axios.interceptors.request.use((config) => {
  let headerToken = localStorage.getItem('token');
  // console.log(headerToken);
  // let headerToken = '1111';
  // config.headers.common['Authorization'] = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJJZCI6MTQ3MzksIlVzZXJOYW1lIjoiMTg1MjAxMjI5NzgtMSIsIk5hbWUiOiIiLCJMWERIIjoiMTg1MjAxMjI5NzgiLCJTeXN0ZW1JZCI6NSwiQ29tcGFueUlkIjoiMyIsIkNvbXBhbnlOYW1lIjoi5YWs5LyXIiwiQ29tcGFueVR5cGUiOjEwMCwiSXNBdXRoZW50aWNhdGVkIjp0cnVlLCJ1c2VyVHlwZSI6MiwiU3RvcmVOYW1lIjoiIiwiVmFsaWRTdGF0ZSI6IiIsIkxvZ2luRGF0ZSI6IlwvRGF0ZSgxNTI4ODg1NjI4MDAwKVwvIn0.cm3IkD1kn1KzXScP-4c84ek9n0269ZjjY3FkXRaiIYQ';
  config.headers.common['Authorization'] = headerToken;
  return config;
}, (error) => {
  return Promise.reject(error);
});

// let activeId = sessionStorage.getItem('activeId');
export function fetch(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(response => {
        if (response.data.Status == -2) {
          // window.location.href = LOG_OUT + "?activeId=" + activeId;
          localStorage.removeItem('token');
          this.$store.commit('SET_USER_INFO','');
          this.$store.commit('SET_LOGINING',false);
          this.$store.commit('SET_ISVERIFY',false);
          window.localStorage.setItem('toWhere',window.location.hash.substr(1,window.location.hash.length-1));
          if(global.loginRouter){
            let obj = new Function(global.loginRouter);
            obj();
          }else{
            router.push({ name: 'signup'})
          }
          // this.$router.push({ name: 'signup' })
          // window.location.replace(global.BASE_URL+'/wechat/login?returnUrl=/h5/index.html$/zhongzhuan');
          resolve(response.data);
        } else {
          resolve(response.data);
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  //post请求,data只有一个参数,用formData格式
  let tempArr = Object.keys(data);
  if (tempArr.length == 1) {
    for(let i in data){
      let key = i;
      let value = data[i];
      if(typeof value == 'string'){
        data = new FormData();
        data.append(key, value);
      }
    }
  }

  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then(response => {
        if (response.data.Status == -2) {
          // window.location.href = LOG_OUT + "?activeId=" + activeId;

          localStorage.removeItem('token');
          this.$store.commit('SET_USER_INFO','');
          this.$store.commit('SET_LOGINING',false);
          this.$store.commit('SET_ISVERIFY',false);
          window.localStorage.setItem('toWhere',window.location.hash.substr(1,window.location.hash.length-1));
          if(global.loginRouter){
            let obj = new Function(global.loginRouter);
            obj();
          }else{
            router.push({ name: 'signup'})
          }
          // this.$router.push({ name: 'signup' })
          // window.location.replace(global.BASE_URL+'/wechat/login?returnUrl=/h5/index.html$/zhongzhuan');
          resolve(response.data);
        } else {
          resolve(response.data);
        }
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        if (response.data.Status == -2) {
          resolve(response.data);
          // window.location.href = LOG_OUT + "?activeId=" + activeId;
        } else {
          resolve(response.data);
        }
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        if (response.data.Status == -2) {
          resolve(response.data);
          // window.location.href = LOG_OUT + "?activeId=" + activeId;
        } else {
          resolve(response.data);
        }
      }, err => {
        reject(err)
      })
  })
}




// WEBPACK FOOTER //
// ./src/utils/http.js